const FlyTypeSection = ({ number, title, purpose, whenToUse, howTheyWork, image, alt, features, proTip }) => (
  <div className="mb-20">
    <div className="bg-[#1E2328] rounded-3xl shadow-xl overflow-hidden border border-white/10">
      <div className="bg-gradient-to-r from-cyan-600 to-cyan-700 px-8 py-6 flex items-center gap-4">
        <div className="w-12 h-12 bg-[#1E2328]/20 rounded-full flex items-center justify-center flex-shrink-0">
          <span className="text-2xl font-bold text-white">{number}</span>
        </div>
        <h2 className="text-3xl font-bold text-white">{title}</h2>
      </div>
      <div className="p-8">
        <div className="grid md:grid-cols-3 gap-6 mb-8">
          <div className="bg-[#151b21] rounded-xl p-6">
            <h3 className="font-bold text-white mb-3">Purpose:</h3>
            <p className="text-slate-400">{purpose}</p>
          </div>
          <div className="bg-[#151b21] rounded-xl p-6">
            <h3 className="font-bold text-white mb-3">When to Use:</h3>
            <p className="text-slate-400">{whenToUse}</p>
          </div>
          <div className="bg-[#151b21] rounded-xl p-6">
            <h3 className="font-bold text-white mb-3">How They Work:</h3>
            <p className="text-slate-400">{howTheyWork}</p>
          </div>
        </div>

        <div className="bg-[#1E2328] rounded-2xl overflow-hidden mb-8 shadow-md">
          <img src={image} alt={alt} className="w-full h-auto object-cover" />
        </div>

        <div className="mb-8">
          <h3 className="text-xl font-bold text-white mb-4">Key Features:</h3>
          <div className="grid md:grid-cols-2 gap-3">
            {features.map((f) => (
              <div key={f} className="flex items-center gap-2">
                <div className="w-2 h-2 bg-cyan-600 rounded-full"></div>
                <span className="text-slate-300">{f}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gradient-to-r from-[#137dc5]/15 to-[#137dc5]/5 rounded-xl p-6">
          <h3 className="font-bold text-[#3aa0e0] mb-2">Pro Tip:</h3>
          <p className="text-slate-300">{proTip}</p>
        </div>
      </div>
    </div>
  </div>
);

export default FlyTypeSection;
